
<template>
  <CRow>
    <CCol sm="12">
      <CCard>
        <CCardHeader class="d-flex align-items-center justify-content-between"
        >
          نظرسنجی‌ها
          <CButton
              color="primary"
              square
              size="sm"
              @click="addPollModal = true"
              class="px-sm-5"
          >
            <CIcon name="cil-plus" />افزودن
          </CButton>
        </CCardHeader>
        <CCardBody class="d-flex align-items-center text-center h-100">
          <CDataTable
              class="
              w-100
              d-flex
              flex-column
              justify-content-between
              align-items-end
              h-100
            "
              :noItemsView="{
              noItems: 'در حال حاضر محتوایی در این قسمت وجود ندارد',
            }"
              :items="computedPoll"
              :fields="fields"
              hover
              striped
              border
              small
              fixed
              :loading="loading"
          >
            <template #text="{ item }">
              <td>
                <div v-if="item.text.length > 30">
                  {{ item.text.slice(0, 30) }}...
                </div>
                <div v-else>{{ item.text }}</div>
              </td>
            </template>
            <template #pollDetails="{ item }">
              <td>
                <router-link :to="`/manager/poll/${item.id}`">
                <CButton
                    color="success"
                    square
                    size="md"
                    class="px-4"
                >
                  مشاهده
                </CButton>
                </router-link>
              </td>
            </template>
            <template #pollEdit="{ item }">
              <td>
                <CButton
                    square
                    size="md"
                    @click="onEditPollModal(item)"
                >
                  <CIcon name="cil-pen"/>
                </CButton>
              </td>
            </template>
            <template #pollRemove="{ item }">
              <td>
                <CButton
                    square
                    size="md"
                    @click="onRemovePollModal(item)"
                >
                  <CIcon name="cil-trash"/>
                </CButton>
              </td>
            </template>
          </CDataTable>
          <AddPollModal v-model="addPollModal" :poll="selectedItem" @get-poll="getPoll"/>
          <EditPollModal v-model="editPollModal" :poll="selectedItem" @get-poll="getPoll"/>
          <RemovePollModal v-model="removePollModal" :poll="selectedItem" @get-poll="getPoll"/>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from "@/plugins/axios";
import AddPollModal from "@/components/Modals/Poll/AddPollModal.vue";
import EditPollModal from "@/components/Modals/Poll/EditPollModal";
import RemovePollModal from "@/components/Modals/Poll/RemovePollModal";

export default {
  components: {
    RemovePollModal,
    EditPollModal,
    AddPollModal,
  },
  name: "Poll",
  data() {
    return {
      poll: [],
      loading: false,
      fields: [
        {key: "title", label: "نام"},
        {key: "text", label: "توضیحات"},
        {key: "computedStartDate", label: "تاریخ شروع"},
        {key: "computedEndDate", label: "تاریخ پایان"},
        {key: "pollEdit", label: "ویرایش"},
        {key: "pollRemove", label: "حذف"},
        {key: "pollDetails", label: "جزئیات"},
      ],
      selectedItem: null,
      addPollModal: false,
      editPollModal: false,
      removePollModal: false
    };
  },
  computed: {
    computedPoll() {
      return this.poll.map((item) => {
        return {
          ...item,
          computedStartDate: item.startDate.replaceAll("-", "/"),
          computedEndDate: item.endDate.replaceAll("-", "/"),
        };
      });
    },
  },
  mounted() {
    this.getPoll();
  },
  methods: {
    async getPoll() {
      try {
        this.loading = true;
        const {data} = await axios.get("/survey");
        this.poll = data;
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
    onEditPollModal(item) {
      this.selectedItem = item
      this.editPollModal = true
    },
    onRemovePollModal(item) {
      this.selectedItem = item
      this.removePollModal = true
    }
  },

};
</script>

<style lang="scss" scoped></style>
